import { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Modal, Divider, useToaster, Message, DatePicker } from "rsuite";
import { isBefore } from "date-fns";
import { selector } from "../../../api";
import moment from "moment";
import { appCRUD } from "../../../actions/app";

const almanacSchema = Yup.object().shape({
  start_date: Yup.string().required("This field is required"),
  end_date: Yup.string()
    .required("This field is required"),
});

const initialValues = {
  start_date: "",
  end_date: "",
};



export const AlmanacAdd = (props) => {
  const { open, setOpen, index, setIndex } = props;
  const user = selector.User();
  const toaster = useToaster();
  const [loading, setLoading] = useState(false);
  const [academicId, setAcademicId] = useState(0)

  useEffect(() => {
    setTimeout(() => {
        appCRUD.loadActiveAcademic().then((resp) => {
            setAcademicId(resp.data[0].id)
        }).catch(() => {})
    },500)
  },[])

  const formik = useFormik({
    initialValues,
    validationSchema: almanacSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { start_date, end_date } = values;
      const recorded_by = user.id;
      const data = {
        academic_year: academicId,
        start_date,
        end_date,
        recorded_by,
      };
      setLoading(true);
      setTimeout(() => {
        if(academicId >= 1){
            appCRUD
              .addAlmanac(data)
              .then(() => {
                toaster.push(
                  <Message type="success" showIcon header={"Success"} closable>
                    <p className="h6">
                      <p className="fw-bold fs-14">Thank you...!</p>
                      <p className="text-dark fs-12">
                        Almanac has been added successfully.
                      </p>
                    </p>
                  </Message>,
                  { placement: "topEnd", duration: 7000 }
                );
                setIndex(index + 1);
                resetForm();
                setLoading(false);
                setSubmitting(false);
                setOpen(false);
              })
              .catch((error) => {
                setLoading(false);
                setSubmitting(false);
                toaster.push(
                  <Message type="error" showIcon header={"Error"} closable>
                    <p className="h6">
                      <p className="fw-bold fs-14">Oooh Sorry...!</p>
                      <p className="text-dark fs-12">{error}.</p>
                    </p>
                  </Message>,
                  { placement: "topEnd", duration: 7000 }
                );
              });
        } else {
            setLoading(false);
            setSubmitting(false);
            toaster.push(
              <Message type="error" showIcon header={"Error"} closable>
                <p className="h6">
                  <p className="fw-bold fs-14">Oooh Sorry...!</p>
                  <p className="text-dark fs-12">{"No active academic year"}.</p>
                </p>
              </Message>,
              { placement: "topEnd", duration: 7000 }
            );
        }
      }, 2000);
    },
  });

  const handleClose = () => {
    setOpen(false);
  };

  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} size="md">
        <Modal.Header>
          <Modal.Title>New Almanac</Modal.Title>
        </Modal.Header>
        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="form-group">
                    <label className="text-body mb-2">
                      Start Date
                      <span className="text-danger">&nbsp;*</span>
                    </label>
                    <DatePicker
                      onChange={(e) => {
                        formik.setFieldValue(
                          "start_date",
                          moment(e).format("yyyy-MM-DD")
                        );
                      }}
                      oneTap
                      placeholder="Start Date"
                      className="w-100"
                      cleanable={false}
                      size="lg"
                    />
                    {formik.touched.start_date && formik.errors.start_date && (
                      <div
                        className="fw-light mt-1"
                        style={{ fontSize: "12px" }}
                      >
                        <span role="alert" className="text-danger">
                          {formik.errors.start_date}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="form-group">
                    <label className="text-body mb-2">
                      End Date
                      <span className="text-danger">&nbsp;*</span>
                    </label>
                    <DatePicker
                      onChange={(e) => {
                        formik.setFieldValue(
                          "end_date",
                          moment(e).format("yyyy-MM-DD")
                        );
                      }}
                      oneTap
                      shouldDisableDate={(date) =>
                          formik.values.start_date
                            ? isBefore(date, formik.values.start_date)
                            : false
                      }
                      className="w-100"
                      placeholder="End Date"
                      cleanable={false}
                      size="lg"
                    />
                    {formik.touched.end_date && formik.errors.end_date && (
                      <div
                        className="fw-light mt-1"
                        style={{ fontSize: "12px" }}
                      >
                        <span role="alert" className="text-danger">
                          {formik.errors.end_date}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Divider style={{ marginTop: -10 }} />
          <Modal.Footer>
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12 d-flex justify-content-start">
                  <span className="fs-18 text-danger"> * &nbsp;</span> Required
                  field
                </div>
                <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                  <button
                    onClick={handleClose}
                    type="button"
                    className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                  >
                    <i class="ri-forbid-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-soft-success btn-label waves-effect waves-light rounded-pill"
                    disabled={formik.isSubmitting}
                  >
                    {!loading && (
                      <span className="indicator-label">
                        <i class="ri-check-double-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                        Save
                      </span>
                    )}
                    {loading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
